import React, { useEffect, useState } from "react";
// import { Link } from "feather-icons-react/build/IconComponents";
import ContactsTab from "./Tabs/Contacts";
import CreditNotesTab from "./Tabs/CreditNotes";
import EstimatesTab from "./Tabs/Estimates";
import ProfileTab from "./Tabs/ProfileTab";
import NotesTab from "./Tabs/Notes";
import StatementTab from "./Tabs/Statements";
import InvoicesTab from "./Tabs/Invoices";
import PaymentsTabs from "./Tabs/Payments";
import ProposalsTab from "./Tabs/Proposals";
import ExpensesTab from "./Tabs/Expenses";
import ProjectsTab from "./Tabs/Projects";
import TasksTab from "./Tabs/Tasks";
import TicketsTab from "./Tabs/Tickets";
import FilesTab from "./Tabs/Files";
import VaultTab from "./Tabs/Vault";
import RemaindersTab from "./Tabs/Remainders";
import MapTab from "./Tabs/Map";
import { Link, useParams } from "react-router-dom";
import { BASE_CRM_URL } from "../../../../components/config/config";
import axios from "axios";
import Swal from "sweetalert2";

import { useLocation } from "react-router-dom";

const CustomerInfo = () => {
  const { id } = useParams();
  const userDetails = JSON.parse(sessionStorage.getItem("userDetails"));
  const userId = userDetails?.staffid;
  console.log(userId, id);

  const [selectedTab, setSelectedTab] = useState({
    value: "Profile",
    label: "Profile",
    icon: "bi-person",
  });

  const options = [
    { value: "Profile", label: "Profile", icon: "bi-person" },
    { value: "Contacts", label: "Contacts", icon: "bi-people" },
    { value: "Notes", label: "Notes", icon: "bi-journal-text" },
    // {
    //   value: "Statement",
    //   label: "Statement",
    //   icon: "bi-file-earmark-bar-graph",
    // },
    { value: "Invoices", label: "Invoices", icon: "bi-receipt" },
    { value: "Payments", label: "Payments", icon: "bi-cash-stack" },
    { value: "Proposals", label: "Proposals", icon: "bi-file-earmark-text" },
    {
      value: "Credit Notes",
      label: "Credit Notes",
      icon: "bi-file-earmark-richtext",
    },
    { value: "Estimates", label: "Estimates", icon: "bi-clipboard-data" },
    { value: "Expenses", label: "Expenses", icon: "bi-credit-card" },
    { value: "Projects", label: "Projects", icon: "bi-kanban" },
    { value: "Tasks", label: "Tasks", icon: "bi-list-task" },
    // { value: "Tickets", label: "Tickets", icon: "bi-ticket-perforated" },
    { value: "Files", label: "Files", icon: "bi-folder" },
    // { value: "Vault", label: "Vault", icon: "bi-shield-lock" },
    { value: "Reminders", label: "Reminders", icon: "bi-bell" },
    // { value: "Map", label: "Map", icon: "bi-map" },
  ];

  const [customerData, setCustomerData] = useState({});

  const renderComponent = () => {
    switch (selectedTab.value) {
      case "Contacts":
        return <ContactsTab />;
      case "Notes":
        return <NotesTab />;
      case "Statement":
        return <StatementTab />;
      case "Invoices":
        return <InvoicesTab CustomerData={customerData} />;
      case "Payments":
        return <PaymentsTabs CustomerData={customerData} />;
      case "Proposals":
        return <ProposalsTab />;
      case "Credit Notes":
        return <CreditNotesTab />;
      case "Estimates":
        return <EstimatesTab />;
      case "Expenses":
        return <ExpensesTab CustomerData={customerData} />;
      case "Projects":
        return <ProjectsTab />;
      case "Tasks":
        return <TasksTab CustomerData={customerData} />;
      case "Tickets":
        return <TicketsTab />;
      case "Files":
        return <FilesTab CustomerData={customerData} />;
      case "Vault":
        return <VaultTab />;
      case "Reminders":
        return <RemaindersTab CustomerData={customerData} />;
      case "Map":
        return <MapTab />;
      case "Profile":
        return <ProfileTab />;
      default:
        return <ContactsTab />;
    }
  };

  const getCustomerDetails = async () => {
    try {
      // setCustomerLoading(true);

      const response = await axios.get(
        `${BASE_CRM_URL}customers/GetCustomerDetails?CusId=${id}`,
      );

      if (response.data.Status) {
        setCustomerData(response.data.ResultData?.[0] || {});
      } else {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: response.data.message || "Unable to fetch customer details.",
        });
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    if (id) {
      getCustomerDetails();
    }
  }, [id]);

  const location = useLocation();

  useEffect(() => {
    if (location.state?.selectedTab) {
      setSelectedTab({
        value: location.state.selectedTab,
        label: location.state.selectedTab,
      });
    }
  }, [location.state]);

  return (
    <div className="page-wrapper">
      <div className="content">
        <div className="">
          <div>
            <div className="d-flex justify-content-between">
              {/* Left section with heading and description */}
              <div className="d-flex flex-column">
                <nav aria-label="breadcrumb">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to="/crm/dashboard">
                        <i className="fas fa-home fa-lg" />
                      </Link>
                    </li>
                    <h4 className="breadcrumb-item " aria-current="page">
                      Customer Info
                    </h4>
                  </ol>
                </nav>
                {/* <p className="text-muted">
                  Manage and add new customers to your database
                </p> */}
              </div>
            </div>
            <div className="d-flex gap-3 align-items-start">
              <div className="col-2">
                <div className="card">
                  <div className="card-body">
                    {options.map((option) => (
                      <div key={option.value}>
                        <button
                          className={`btn w-100 text-start d-flex align-items-center mb-2 ${
                            selectedTab.value === option.value
                              ? "btn-outline-primary"
                              : "btn border-0"
                          }`}
                          onClick={() => setSelectedTab(option)}
                        >
                          <i className={`bi ${option.icon} me-2`}></i>
                          {option.label}
                        </button>
                      </div>
                    ))}
                  </div>
                </div>
              </div>
              <div className="col-10">
                <div className="card">
                  <div className="card-header d-flex justify-content-between align-items-center">
                    <h5 className="card-title">
                      <i className={`bi ${selectedTab.icon} me-2`}></i>
                      {selectedTab.value} -{" "}
                      <strong className="text-primary">
                        {customerData?.company}
                      </strong>
                    </h5>
                    <div className="d-flex">
                      <div className="dropdown d-none">
                        <button
                          className="btn btn-secondary dropdown-toggle w-100"
                          type="button"
                          id="dropdownMenuButton"
                          data-bs-toggle="dropdown"
                          aria-expanded="false"
                          style={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "space-between",
                          }}
                        >
                          <i className={`bi ${selectedTab.icon} me-2`}></i>
                          {selectedTab.label}
                        </button>
                        <ul
                          className="dropdown-menu w-100"
                          aria-labelledby="dropdownMenuButton"
                          style={{
                            maxHeight: "300px",
                            overflowY: "auto",
                            width: "100%",
                          }}
                        >
                          {options.map((option) => (
                            <li key={option.value}>
                              <button
                                className="dropdown-item d-flex align-items-center"
                                onClick={() => setSelectedTab(option)}
                              >
                                <i className={`bi ${option.icon} me-2`}></i>
                                {option.label}
                              </button>
                            </li>
                          ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                  <div className="card-body">{renderComponent()}</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default CustomerInfo;
